"use client";
import "./sectionHeading.css";
export default function SectionHeading({ title, subtitle, align = "center", maxWidth = 900, miniTitle = "", miniHighlight = "" }) {
  return (
    <div
      style={{
        textAlign: align,
        maxWidth: align === "center" ? maxWidth : undefined,
        margin: align === "center" ? "0 auto 30px" : "0 0 40px",
      }}
    >
      {(miniTitle || miniHighlight) && (
        <div
          className="top-heading-wrapper"
          style={{
            justifyContent: align === "center" ? "center" : "flex-start",
          }}
        >
          <span className="divider left" />
          <h2 className="top-heading">
            <span className="title-part">{miniTitle}</span>
            {miniHighlight && <span className="highlight-part">{miniHighlight}</span>}
          </h2>
          <span className="divider" />
        </div>
      )}

      <h2 className="main-title">{title}</h2>
      {subtitle && <p className="section-heading">{subtitle}</p>}
    </div>
  );
}
